// extracted by mini-css-extract-plugin
export default {"main":"MainContainer_main__+l04n"};